import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppButton";
import { waLink, PHONE_TEL } from "../data/siteData";

const spring = { delay: 1.6, type: "spring", stiffness: 200, damping: 16 };

export const WhatsAppFloat = () => (
  <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3">
    <motion.a
      href={PHONE_TEL}
      data-testid="call-float-button"
      aria-label="Call Belong Spa"
      className="flex h-14 w-14 items-center justify-center rounded-full border border-amber-400/40 bg-[#0B0B0C]/90 text-amber-300 shadow-[0_10px_35px_rgba(212,175,55,0.25)] backdrop-blur-md transition-transform duration-300 hover:scale-110"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ ...spring, delay: 1.75 }}
    >
      <Phone className="h-6 w-6" strokeWidth={2} />
    </motion.a>
    <motion.a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Book on WhatsApp"
      className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_35px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-110"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={spring}
    >
      <WhatsAppIcon className="h-7 w-7" />
    </motion.a>
  </div>
);
